<template>
  <section class="bg-white mb-[100px] mt-[60px] md:my-[100px]">
    <div class="container w-full md:flex md:flex-col md:items-center">
      <div
        class="text-[22px] leading-8 md:text-4xl md:leading-[46px] uppercase text-black font-bold font-ff-good-pro-cond text-center"
        v-text="$t('common.warranty_request')"
      ></div>

      <p
        v-text="$t('common.warranty_request_description')"
        class="text-center md:w-[752px] font-normal text-black italic my-4 lg:mt-4 lg:mb-[40px] font-ff-good-pro-cond text-lg leading-7 md:text-[28px] md:leading-[34px]"
      ></p>

      <div class="md:grid md:grid-cols-2 md:gap-6">
        <img
          src="/public/warranty/warranty_request_1.png"
          class="bg-no-repeat rounded-md object-cover h-[435px] md:h-[655px] w-full"
          alt="Request 1"
        />
        <img
          src="/public/warranty/warranty_request_2.png"
          class="bg-no-repeat rounded-md object-cover h-[435px] md:h-[655px] mt-[10px] md:mt-0 w-full"
          alt="Request 2"
        />
      </div>
    </div>
  </section>
</template>
<script setup></script>
